// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"ea3ff2d0","617":"4b0538f6","877":"2249fd6c","968":"dfec48f1","983":"489cddd7"}[chunkId] + ".chunk.js";
};